import {GetAuthDetailModel} from 'domain/usecases';
import {Status} from './cardByStatus';

interface IRequestDetailProps extends Omit<GetAuthDetailModel, 'dsSituacao'> {
	dsSituacao: Status;
}

const LIST_SIZE = 12;

export type {IRequestDetailProps};
export {LIST_SIZE};
